import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { Breadcrumb, Button } from 'antd'
import { BreadcrumbNameMap } from '@/config'
import styles from './index.module.less'

// 面包屑配置，允许更改面包屑名称
// const updateNameRoutes = [
//   'collectorTemplate/edit'
// ]


const NavBreadcrumb = () => {
  const location = useLocation()
  const navigate = useNavigate() // 使用 useNavigate hook 进行导航
  const [params] = useSearchParams();
  const pName = params.get("name")
  const { pathname } = location
  if (!BreadcrumbNameMap[pathname]) {
    return null
  }
  const pathSnippets = location.pathname.split('/').filter(i => i)
  const handleClick = (url, index) => {
    // 在这里可以加入你想要的跳转逻辑
    console.log(`Navigating to ${url}`)
    if (index == 0) return;
    navigate(url)
  }

  const editUrlPatterns = [
    'collectorTemplate/edit',
    'standard/edit',
    'collectTemplateRules/edit',
    'costControlCompare/result',
    '/document/engList/detail',
    '/document/packageTemplateList/view',
    '/document/engList/dir',
  ]

  // 获取最后一个名称，允许特定路由更改面包屑名称
  const getLastName = (url: string) => {
    if (editUrlPatterns.some(pattern => url.includes(pattern))) {
      return `${BreadcrumbNameMap[url]}-${pName}`
    }
    return BreadcrumbNameMap[url]
  }

  const extraBreadcrumbItems = pathSnippets.map((_, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join('/')}`
    const last = index === pathSnippets.length - 1
    // let lastName = BreadcrumbNameMap[url]
    // console.log("url", url)
    return {
      key: url,
      title: last ? (
        <span>{getLastName(url)}</span>
      ) : (
        // <Link to={url}>{BreadcrumbNameMap[url]}</Link>
        <a
          type='link'
          className={styles['link']}
          onClick={() => handleClick(url, index)} // 点击事件来控制跳转
          style={{ cursor: 'pointer' }} // 样式调整为可点击状态 ,color: '#1890ff'
        >
          {BreadcrumbNameMap[url]}
        </a>
      ),
    }
  })

  return <Breadcrumb className={styles.container} items={extraBreadcrumbItems} />
}

export default NavBreadcrumb
